import React from 'react';
import { Link } from 'react-router';
import MarketingSearchForm from './marketing-search-form';
import MarketingSearchTabs from './marketing-search-tabs';
import AppRoutes from '../../routes/routes';
import homepageBanner from '../../../images/homepage-banner-min.png';
import neuroBgImage from '../../../images/NEUROCHECKLISTS-bg-img.png';
import logoWhite from '../../../images/logo-white.svg';

export default class MarketingHero extends React.Component {
    constructor() {
        super();

        this.state = {
            searchMode: 'axon'
        };
        this.handleSearchModeChange = this.handleSearchModeChange.bind(this);
    }

    handleSearchModeChange(mode) {
        this.setState({ searchMode: mode });
    }

    render() {
        return (
            <section className="hero">
                {/* Background images */}
                <div className="hero-bg-banner" style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundImage: `url(${homepageBanner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: 0.4,
                    pointerEvents: 'none'
                }}></div>
                <div className="hero-bg-neuro" style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url(${neuroBgImage})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'left center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.15,
                    pointerEvents: 'none'
                }}></div>

                <div className="hero-grid"></div>
                <div className="hero-glow"></div>

                {/* Neuron nodes decorative */}
                <div className="neuron-canvas" aria-hidden="true">
                    <div className="neuron-node" style={{ width: 6, height: 6, top: '18%', left: '12%', animationDelay: '.8s', background: 'rgba(37,99,235,.6)' }}></div>
                    <div className="neuron-node" style={{ width: 4, height: 4, top: '35%', left: '8%', animationDelay: '1.1s', background: 'rgba(93,163,251,.4)' }}></div>
                    <div className="neuron-node" style={{ width: 8, height: 8, top: '62%', left: '15%', animationDelay: '.5s', background: 'rgba(37,99,235,.5)' }}></div>
                    <div className="neuron-node" style={{ width: 5, height: 5, top: '78%', left: '22%', animationDelay: '1.4s', background: 'rgba(93,163,251,.3)' }}></div>
                    <div className="neuron-node" style={{ width: 6, height: 6, top: '20%', right: '14%', animationDelay: '.9s', background: 'rgba(37,99,235,.6)' }}></div>
                    <div className="neuron-node" style={{ width: 4, height: 4, top: '42%', right: '9%', animationDelay: '1.2s', background: 'rgba(93,163,251,.4)' }}></div>
                    <div className="neuron-node" style={{ width: 7, height: 7, top: '70%', right: '18%', animationDelay: '.6s', background: 'rgba(37,99,235,.5)' }}></div>
                    <div className="neuron-line" style={{ top: '28%', left: '10%', width: 140, transform: 'rotate(15deg)', animationDelay: '1s' }}></div>
                    <div className="neuron-line" style={{ top: '55%', left: '6%', width: 100, transform: 'rotate(-20deg)', animationDelay: '1.3s' }}></div>
                    <div className="neuron-line" style={{ top: '32%', right: '8%', width: 120, transform: 'rotate(170deg)', animationDelay: '1.1s' }}></div>
                </div>

                <Link to={AppRoutes.homepage} className="hero-logo" aria-label="Neurochecklists home">
                    <img src={logoWhite} alt="Neurochecklists" />
                </Link>

                <div className="hero-badge">
                    <span className="hero-badge-dot"></span>
                    Now in open research beta
                </div>

                <h1 className="hero-h1"><strong>Everything neurology a click away</strong></h1>

                <p className="hero-sub">The Leading Neurology Checklist Database, access peer-reviewed criteria, diagnostic protocols, and treatment guidelines in seconds.</p>

                <div className="hero-search-container">
                    <MarketingSearchTabs
                        activeTab={this.state.searchMode}
                        onTabChange={this.handleSearchModeChange}
                    />
                    <MarketingSearchForm
                        {...this.props}
                        searchMode={this.state.searchMode}
                    />
                </div>

                {((this.props.recentSearches && this.props.recentSearches.length > 0) ||
                  (this.props.popularSearches && this.props.popularSearches.length > 0)) && (
                    <div className="hero-quick-access">
                        {this.props.recentSearches && this.props.recentSearches.length > 0 && (
                            <div className="hero-quick-section">
                                <h4 className="hero-quick-title">Your recent searches</h4>
                                <div className="hero-quick-pills">
                                    {this.props.recentSearches
                                        .filter(item => item && item.title && item._slugs && item._slugs[0])
                                        .slice(0, 5)
                                        .map((item, idx) => (
                                            <Link
                                                key={`recent-${idx}`}
                                                to={`${AppRoutes.checklists}${item._slugs[0]}`}
                                                className="hero-quick-pill"
                                            >
                                                {item.title}
                                            </Link>
                                        ))}
                                </div>
                            </div>
                        )}
                        {this.props.popularSearches && this.props.popularSearches.length > 0 && (
                            <div className="hero-quick-section">
                                <h4 className="hero-quick-title">Popular searches</h4>
                                <div className="hero-quick-pills">
                                    {this.props.popularSearches.slice(0, 8).map((item, idx) => (
                                        <Link
                                            key={`popular-${idx}`}
                                            to={`${AppRoutes.checklists}${item._slugs[0]}`}
                                            className="hero-quick-pill"
                                        >
                                            {item.title}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="hero-stats">
                    <div>
                        <div className="hero-stat-num">4,000+</div>
                        <div className="hero-stat-label">Neurological checklists</div>
                    </div>
                    <div className="stat-divider"></div>
                    <div>
                        <div className="hero-stat-num">98%</div>
                        <div className="hero-stat-label">Source citation accuracy</div>
                    </div>
                </div>
            </section>
        );
    }
}
